"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

var _colors = _interopRequireWildcard(require("./colors"));

var _fonts = _interopRequireDefault(require("./fonts"));

var theme = (0, _styles.createMuiTheme)({
  typography: {
    // Used to force the usage of the new typography variants.
    // See: https://material-ui.com/style/typography/#migration-to-typography-v2
    fontFamily: ['Source Sans Pro'].join(','),
    h1: _fonts["default"].h1,
    h2: _fonts["default"].h2,
    h3: _fonts["default"].h3,
    h4: _fonts["default"].h4,
    h5: _fonts["default"].h5,
    h6: _fonts["default"].h6,
    subtitle1: _fonts["default"].subtitle1,
    subtitle2: _fonts["default"].subtitle2,
    body1: _fonts["default"].body1,
    body2: _fonts["default"].body2,
    caption: _fonts["default"].caption,
    overline: _fonts["default"].overline,
    button: _fonts["default"].button
  },
  palette: {
    primary: {
      main: _colors["default"].liva[500]
    },
    text: {
      primary: _colors.textPrimaryColor,
      secondary: _colors.textSecondaryColor,
      disabled: _colors.textDisabledColor
    }
  },
  spacing: function spacing(value) {
    return value * 4;
  }
});
var _default = theme;
exports["default"] = _default;